import { define } from '../redux-request';
import api from '../../api/api';
import accountHelpers from '../../utils/accountHelpers';

export const LOGIN_REQUEST = define('LOGIN_REQUEST');

export function loginRequest(data) {
  return LOGIN_REQUEST.request(() => api.login(data));
}

export const CHANGE_PASSWORD = define('CHANGE_PASSWORD');

export function changePasswordRequest(data) {
  return CHANGE_PASSWORD.request(() => {
    if (data?.token) {
      return api.setNewPassword(data);
    }

    return api.changePassword(data);
  });
}

export const GET_ACCOUNT_REQUEST = define('GET_ACCOUNT_REQUEST');

export function getAccountRequest(userId) {
  return GET_ACCOUNT_REQUEST.request(() => api.getAccount(userId));
}

export const logout = () => {
  window.location.href = '/login';
  accountHelpers.removeLocalStorage();
};
